<div class="attendance-header d-flex justify-content-between align-items-center">

  <div>
    <h2 mat-dialog-title class="mb-1 fw-bold">
      Update Mark Attendance
    </h2>

    <small class="event-name">
      <i class="bi bi-calendar-event me-1"></i>
      {{ EventId }}
    </small>
  </div>


  <button
    type="button"
    class="close-btn"
    mat-dialog-close
  >
    <i class="bi bi-x-lg"></i>
  </button>

</div>
<mat-dialog-content>
  <form [formGroup]="eventMarkAttendanceForm">

    <div class="table-responsive">
      <table class="table table-striped table-bordered table-hover" style="font-size: 9.5pt">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Udyam Registration Number</th>
            <th>Name Of Enterprise</th>
            <th>Participant Name</th>
            <th>Mobile Number</th>
            <th>Enrollment Id</th>
            <th>Is Checked</th>
                <th>Note</th>
          </tr>
        </thead>




        <tbody>
          <tr *ngFor="let item of reportData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.UdyamRegistrationNumber }}</td>
            <td>{{ item.NameOfEnterprise }}</td>
            <td>{{ item.ParticipantName }}</td>
            <td>{{ item.MobileNumber }}</td>
            <td>{{ item.EnrollmentId }}</td>
    
            <td>
              <input
                type="checkbox"
                [checked]="item.IsChecked"
                (change)="onCheckboxChange($event, item)"
                  [disabled]="item.isDisabled"
              />
            </td>
                <td>    <span *ngIf="item.isDisabled" class="text-success ms-2">
    ✔ Participant has already provided feedback
  </span></td>
          
          </tr>
        </tbody>
      </table>
    </div>

    <!-- NO PARTICIPANTS -->
    <div *ngIf="showNoParticipantsMessage"
         class="text-center p-3 border rounded mb-3 bg-light">

      <div class="form-check d-flex justify-content-center align-items-center">
        <input type="checkbox" formControlName="declarationAccepted" />
        <label class="ms-2 text-danger fw-bold">
          Since there are no enrolled participants, attendance cannot be marked.
        </label>
      </div>

    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <!-- <button mat-button color="primary"
          (click)="onSubmit('draft')"
          [disabled]="showNoParticipantsMessage">
    Save as Draft
  </button> -->
<!-- 
  <button mat-button color="accent"
          (click)="onSubmit('submit')">
    Submit
  </button>

  <button mat-button mat-dialog-close>
    Close
  </button> -->



  <div class="d-flex justify-content-end gap-2 mt-3">

  <!-- Submit -->
  <button 
    mat-raised-button 
    color="primary"
    (click)="onSubmit('submit')">
    Submit 
  </button>

  <!-- Close -->
  <button 
    mat-stroked-button 
    color="warn"
    mat-dialog-close>
    Close
  </button>

</div>
</mat-dialog-actions>
